import { useLocation } from 'react-router';
import { getURLPart } from '../Features/Routing/Utils/authorizationUtils';
import { styrvardeRouteName } from '../Features/Routing/router';

export const useIsStyrvarde = (): boolean => {
  const location = useLocation();
  const urlPart = getURLPart(2, location.pathname);

  return urlPart === styrvardeRouteName.toLowerCase();
};
